// extracted by mini-css-extract-plugin
module.exports = {"leaderboardFirst":"e_2","leaderboardSecond":"e_3"};